import { render, staticRenderFns } from "./loginrecord.vue?vue&type=template&id=526280f2"
import script from "./loginrecord.vue?vue&type=script&lang=js"
export * from "./loginrecord.vue?vue&type=script&lang=js"
import style0 from "./loginrecord.vue?vue&type=style&index=0&id=526280f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports